import React, {useContext, useState} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select, Switch} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import { Escola } from '../../../model/root/Escola';
import { PostEscoles } from '../../../dao/root/PostEscoles';
import TextArea from 'antd/es/input/TextArea';
import {AuthContext} from "../../../config/AuthContext";

interface IngredientModalProps {
    element: Escola;
    visible: boolean;
    menus: { label: string; value: string; }[];
    page: string;
    onClose: () => void;
}

const EscolesModal: React.FC<IngredientModalProps> = ({element, visible, menus, page, onClose}) => {
    const [form] = Form.useForm();
    const {userId} = useContext(AuthContext);

    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        const nom = await form.getFieldValue('nom');
        const comentaris = await form.getFieldValue('comentaris');
        const id_loop = await form.getFieldValue('id_loop');
        const menjador = await form.getFieldValue('menjador');
        const extraescolars = await form.getFieldValue('extraescolars');
        const casals = await form.getFieldValue('casals');
        const referent = await form.getFieldValue('referent');
        const proposta = await form.getFieldValue('proposta');
        const menu = await form.getFieldValue('menu');
        await PostEscoles(id, nom, comentaris, id_loop, menjador, extraescolars, casals, referent, proposta, menu, page, userId);
        await onClose();
    }

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    async function handleCancel() {

        await onClose();
    };
    const [menu, setMenu] = useState(element.menu);

    return(
        <Modal
            title="Crear/Editar Escola"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={600}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                            rules={[{ required: true, message: 'Introdueix el nom de l\'escola'}]}>
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Comentaris" name="comentaris">
                                <TextArea rows={8}/>
                        </Form.Item>
                        <Form.Item label="Id loop" name="id_loop"
                            rules={[{ required: true, message: 'Introdueix el id Loop'}]}>
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Referent" name="referent">
                                <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Menjador" name="menjador">
                            <Switch />
                        </Form.Item>
                        <Form.Item label="Casal" name="casals">
                            <Switch />
                        </Form.Item>
                        <Form.Item label="Extraescolar" name="extraescolars">
                            <Switch />
                        </Form.Item>
                        <Form.Item label="Proposta comanda" name="proposta">
                            <Switch />
                        </Form.Item>
                        <Form.Item label="Menus" name="menu">
                            <Select showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}
                                    options={menus}
                                    onChange={(text, index) => {
                                        setMenu(text);
                                    }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>

    )
};

export default EscolesModal;